import { TemplateRef } from '@angular/core';
import * as R from 'ramda';

import { FeatureGuide } from './feature-guide';
import { FeatureGuidePosition } from './feature-guide-position';

export const COMPLETED_FEATURE_GUIDES_STORAGE_KEY = 'completedFeatureGuides';

type GetFeatureGuideId = (featureGuide: FeatureGuide) => string;
export const getFeatureGuideId: GetFeatureGuideId = R.prop('id');

type GetFeatureGuideTitle = (featureGuide: FeatureGuide) => string;
export const getFeatureGuideTitle: GetFeatureGuideTitle = R.prop('title');

type IsPrimaryFeatureGuide = (featureGuide: FeatureGuide) => boolean;
export const isPrimaryFeatureGuide: IsPrimaryFeatureGuide = R.prop('primary');

type GetFeatureGuideTemplate = (featureGuide: FeatureGuide) => TemplateRef<any>;
export const getFeatureGuideTemplate: GetFeatureGuideTemplate = guide =>
  R.prop('template', guide) as TemplateRef<any>;

type GetFeatureGuidePosition = (featureGuide: FeatureGuide) => FeatureGuidePosition;
export const getFeatureGuidePosition: GetFeatureGuidePosition = R.prop('position');

type GetFeatureGuideActiveClass = (featureGuide: FeatureGuide) => string;
export const getFeatureGuideActiveClass: GetFeatureGuideActiveClass = R.prop('activeClass');
